import React from "react";
import Main from "../components/sections/profile/Main";

export const Profile = () => {
  return <Main />;
};
